import { render, staticRenderFns } from "./eb-avatar.vue?vue&type=template&id=49fe98a7&"
import script from "./eb-avatar.vue?vue&type=script&lang=js&"
export * from "./eb-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports